module.exports = __webpack_public_path__ + "img/AF.d8fb0d22.svg";